exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro);", ""]);

// module
exports.push([module.id, ".arrow-down {\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 8px solid #444;\n  height: 0;\n  width: 0; }\n\n.btn {\n  background-color: #fafafa;\n  border: 1px solid #c6c6c6;\n  border-radius: 3px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n  color: #222;\n  height: 36px; }\n  .btn:hover {\n    cursor: pointer; }\n\n.highlight {\n  color: #eb6614;\n  font-weight: bolder; }\n\n.visuallyHidden,\nspan[aria-hidden] {\n  display: none; }\n\n:host .container {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.95rem;\n  margin: 0 auto;\n  padding-top: 25px;\n  width: 300px; }\n  :host .container .github {\n    color: #444;\n    display: block;\n    font-size: 0.85rem;\n    margin-top: 35px;\n    text-align: center;\n    text-decoration: none; }\n    :host .container .github img {\n      height: 20px;\n      margin-right: 5px;\n      vertical-align: middle; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/donate.component.scss
// module id = ../../../../../src/app/main/donate/donate.component.scss
// module chunks = main